import { computed, ref } from 'vue'

export interface City {
  id: number
  name: string
}

export function normalizeText(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

export function useCityFetch() {
  const cities = ref<City[]>([])
  const isLoading = ref(false)
  const errorMessage = ref<string | null>(null)
  const searchQuery = ref('')
  const selectedCity = ref<City | null>(null)

  const fetchCities = async (stateAbbreviation: string) => {
    isLoading.value = true
    errorMessage.value = null
    cities.value = []
    selectedCity.value = null

    try {
      const url = `/api/v1/brasilapi/municipios/${stateAbbreviation}`
      console.log('Fetching cities from:', url)
      const response = await fetch(url)
      console.log('Response status:', response.status)

      if (response.ok) {
        const data = await response.json()

        // Verifica se há erro na resposta
        if (data.erro) {
          console.error('API error:', data.erro)
          errorMessage.value = 'Erro ao carregar cidades'
          return
        }

        // Mapeia a resposta da Brasil API para o formato esperado
        cities.value = data.map((city: { nome: string; codigo_ibge: string }) => ({
          id: Number(city.codigo_ibge),
          name: city.nome,
        }))
        console.log('Cities received:', cities.value.length)
      } else {
        console.error('Error response:', response.status)
        errorMessage.value = 'Erro ao carregar cidades'
      }
    } catch (error) {
      console.error('Error fetching cities:', error)
      errorMessage.value = 'Erro ao carregar cidades'
    } finally {
      isLoading.value = false
    }
  }

  const filteredCities = computed(() => {
    if (!searchQuery.value) return cities.value
    const normalizedQuery = normalizeText(searchQuery.value)
    return cities.value.filter((city) => normalizeText(city.name).includes(normalizedQuery))
  })

  const selectCity = (city: City) => {
    selectedCity.value = city
  }

  const reset = () => {
    cities.value = []
    selectedCity.value = null
    searchQuery.value = ''
    errorMessage.value = null
  }

  return {
    cities,
    filteredCities,
    isLoading,
    errorMessage,
    searchQuery,
    selectedCity,
    fetchCities,
    selectCity,
    reset,
  }
}
